{
  "blue": {
    "default": "hue",
    "hue": "rgb(0, 98, 227)",
    "light": "rgb(204, 224, 249)",
    "dark": "rgb(0, 70, 176)",
    "a08": "rgba(0, 98, 227, 0.08)",
    "a50": "rgba(0, 98, 227, 0.5)",
    "a80": "rgba(0, 98, 227, 0.8)"
  },
  "green": {
    "default": "hue",
    "hue": "rgb(0, 168, 102)",
    "light": "rgb(204, 238, 224)",
    "dark": "rgb(0, 117, 71)"
  },
  "yellow": {
    "default": "hue",
    "hue": "rgb(240, 180, 0)",
    "light": "rgb(252, 240, 204)",
    "dark": "rgb(145, 102, 0)"
  },
  "red": {
    "default": "hue",
    "hue": "rgb(222, 5, 70)",
    "light": "rgb(248, 205, 218)",
    "dark": "rgb(171, 3, 65)"
  },
  "ebony": {
    "default": "hue",
    "hue": "rgb(15, 31, 44)",
    "a75": "rgba(15, 31, 44, 0.75)",
    "a75-hue": "rgb(75, 87, 97)",
    "a61": "rgba(15, 31, 44, 0.61)",
    "a61-hue": "tint(#0f1f2c, 39%)",
    "a45": "rgba(15, 31, 44, 0.45)",
    "a45-hue": "tint(#0f1f2c, 55%)",
    "a25": "rgba(15, 31, 44, 0.25)",
    "a25-hue": "tint(#0f1f2c, 75%)",
    "a20": "rgba(15, 31, 44, 0.2)",
    "a20-hue": "tint(#0f1f2c, 80%)",
    "a18": "rgba(15, 31, 44, 0.18)",
    "a18-hue": "tint(#0f1f2c, 82%)",
    "a08": "rgba(15, 31, 44, 0.08)",
    "a08-hue": "tint(#0f1f2c, 92%)",
    "a03": "rgba(15, 31, 44, 0.03)",
    "a03-hue": "tint(#0f1f2c, 97%)"
  },
  "white": {
    "default": "hue",
    "hue": "rgb(255, 255, 255)",
    "a90": "rgba(255, 255, 255, 0.9)",
    "a80": "rgba(255, 255, 255, 0.8)",
    "a75": "rgba(255, 255, 255, 0.75)",
    "a50": "rgba(255, 255, 255, 0.5)",
    "a20": "rgba(255, 255, 255, 0.2)"
  },
  "coral": {
    "default": "hue",
    "hue": "rgb(245, 78, 49)",
    "light": "rgb(253, 220, 214)",
    "medium": "rgb(246, 162, 148)",
    "dark": "rgb(194, 52, 27)"
  },
  "forest": {
    "default": "hue",
    "hue": "rgb(61, 168, 7)",
    "light": "rgb(216, 238, 205)",
    "medium": "rgb(153, 207, 126)",
    "dark": "rgb(41, 117, 4)"
  },
  "fuchsia": {
    "default": "hue",
    "hue": "rgb(184, 68, 189)",
    "light": "rgb(241, 215, 242)",
    "medium": "rgb(215, 157, 217)",
    "dark": "rgb(133, 18, 138)"
  },
  "ocean": {
    "default": "hue",
    "hue": "rgb(0, 166, 166)",
    "light": "rgb(204, 237, 237)",
    "medium": "rgb(123, 206, 206)",
    "dark": "rgb(0, 115, 115)"
  },
  "orange": {
    "default": "hue",
    "hue": "rgb(232, 116, 0)",
    "light": "rgb(250, 227, 204)",
    "medium": "rgb(239, 181, 123)",
    "dark": "rgb(181, 78, 0)"
  },
  "pink": {
    "default": "hue",
    "hue": "rgb(235, 61, 125)",
    "light": "rgb(251, 216, 232)",
    "medium": "rgb(240, 153, 185)",
    "dark": "rgb(184, 28, 98)"
  },
  "purple": {
    "default": "hue",
    "hue": "rgb(127, 67, 224)",
    "light": "rgb(229, 217, 249)",
    "medium": "rgb(187, 157, 235)",
    "dark": "rgb(86, 42, 173)"
  },
  "sky": {
    "default": "hue",
    "hue": "rgb(0, 159, 217)",
    "light": "rgb(204, 236, 247)",
    "medium": "rgb(123, 202, 231)",
    "dark": "rgb(0, 112, 153)"
  },
  "success": {
    "default": "hue",
    "hue": "rgb(0, 168, 102)",
    "light": "rgb(204, 238, 224)",
    "dark": "rgb(0, 117, 71)"
  },
  "warning": {
    "default": "hue",
    "hue": "rgb(240, 180, 0)",
    "light": "rgb(252, 240, 204)",
    "dark": "rgb(145, 102, 0)"
  },
  "static": {
    "default": "hue",
    "hue": "rgb(240, 180, 0)",
    "light": "rgb(252, 240, 204)",
    "dark": "rgb(145, 102, 0)"
  },
  "pending": {
    "default": "hue",
    "hue": "rgb(240, 180, 0)",
    "light": "rgb(252, 240, 204)",
    "dark": "rgb(145, 102, 0)"
  },
  "error": {
    "default": "hue",
    "hue": "rgb(222, 5, 70)",
    "light": "rgb(248, 205, 218)",
    "dark": "rgb(171, 3, 65)"
  },
  "decrease": {
    "default": "hue",
    "hue": "rgb(222, 5, 70)",
    "light": "rgb(248, 205, 218)",
    "dark": "rgb(171, 3, 65)"
  },
  "destructive": {
    "default": "hue",
    "hue": "rgb(222, 5, 70)",
    "light": "rgb(248, 205, 218)",
    "dark": "rgb(171, 3, 65)"
  }
}